import React, { memo } from 'react'

import ReceiveReward from '../../../components/reward/ReceiveReward'

const ReceiveRewardWrapper = (props) => {
  return <ReceiveReward {...props} />
}

export default memo(ReceiveRewardWrapper)
